// extracted by mini-css-extract-plugin
export var container = "_j7-0";
export var dotAnimation = "_j7-2";
export var dotsLoading = "_j7-1";